import { gql } from '@apollo/client';

export const CONTACT_MUTATION = gql`
  mutation Lead($input: LeadInput!) {
    lead(input: $input) {
      contact {
        success
      }
    }
  }
`;
